const MapModal = () => import("@/components/common/mapModal/Index");
const ModelNase = () => import("@/components/tables/ModelNase/ModelNase.vue");
const newGroupingPage = () => import("./newGroup.vue");
const batchCreatePage = () => import("./batchCreatePage.vue");
const ModalEditor = () => import("../ModelNase/ModalEditor");

import {
  BimGltfGroupingList,
  BimGltfGroupingAdd,
  BimGltfGroupingEdit,
  BimGltfGroupingDelete,
  BimGltfPaintingDelete,
  BimGltfPaintingEdit,
  BimGltfPaintingAdd,
} from "@/api/api";
import { set } from "lodash";
import * as modelSetMap from "./modelSetMap";

export default {
  name: "viewpoint",
  components: {
    MapModal,
    newGroupingPage,
    ModelNase,
    batchCreatePage,
    ModalEditor,
  },
  props: {
    selectedScene: Object, //从父组件传递过来的当前选中的项目item
  },
  data() {
    return {
      viewpoint: {
        title: "小模型库",
        id: "modelSet",
      },
      modalNode: {
        viewpoint: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            // x: 106,
            // y: -376,
            x: 55,
            y: -340,
            // unit: "px", // 默认px
          },
          width: "280px",
          // auto 自适应
          // height: `${document.querySelector(".cesium-widget").offsetHeight - 30}px`, // 配置模态框中心高度
          height: `${document.querySelector("#mars3d-container").offsetHeight -
            140}px`,
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "id", // id和ref使用的同一个
            name: "name", // 树的展示字段 默认name
            expand: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            checkeArr: [],
            search: {
              keywords: "name", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            checkBoxClick: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      newPageShow: false,
      selectTreeData: null,
      editTreeData: null,
      shidianArr: [],
      initialIndex: 0,
      setIntervals: null,
      viewpointNode: {
        newGroupingCategory: {
          show: false, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -650,
          },
          // width: "450px", // 宽度配置 默认450px
          height: "210px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      viewpointRules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
      },
      viewpointForm: {
        name: "",
        id: "",
      },
      modelNaseShow: false,
      batchCreateShow: false,
      modalEditorShow: false,
      childrenEditData: false,
    };
  },
  methods: {
    getData() {
      BimGltfGroupingList({
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
      })
        .then((res) => {
          if (res.data.code == 200) {
            // 二级分组新增编辑删除
            const operateGroupingList = [
              {
                i_icon: "small-operation-btn el-icon-edit",
                click: (e) => this.editTree(e),
              },
              {
                i_icon: "small-operation-btn el-icon-delete",
                click: (e) => this.deleteTree(e),
              },
            ];
            if (res.data.data.length > 0) {
              res.data.data.forEach((item) => {
                item.operate = operateGroupingList;
                if (item.children.length > 0) this.recursion(item.children);
              });
            }
            this.modalNode.viewpoint.content.treeDataJson = res.data.data;
            if (this.selectTreeData) {
              setTimeout(() => {
                this.$refs.MapModal.$refs.modalTree[0].setCurrentKey(
                  this.selectTreeData.id
                );
              }, 10);
            }
          }
        })
        .catch((err) => {});
    },
    // 递归处理树数据
    recursion(data) {
      const threeObj = [
        {
          i_icon: "small-operation-btn el-icon-edit",
          click: (e) => this.childrenEdit(e),
        },
        {
          i_icon: "small-operation-btn el-icon-delete",
          click: (e) => this.childrenDelete(e),
        },
      ];
      data.forEach((item) => {
        item.operate = threeObj;
      });
      // console.log(checkeArr);
      // return data;
    },
    createModel(value) {
      if (this.selectTreeData) {
        if (this.selectTreeData.groupId) {
          this.modalNode.viewpoint.content.treeDataJson.forEach((el) => {
            if (el.id == this.selectTreeData.groupId) {
              this.selectTreeData = el;
            }
          });
        }

        // this.modalNode.viewpoint.head.fold.state = false;
        this.modalNode.viewpoint.show = false;
        this.modelNaseShow = true;
        setTimeout(() => {
          this.$refs.ModelNase.modalNode.ModelNase.show = true;
          if (value) {
            this.$refs.ModelNase.batchData = value;
          } else {
            this.$refs.ModelNase.batchData = null;
          }
        }, 100);
      } else {
        this.$message({
          message: "请先选中一条分组！",
          type: "warning",
          duration: 1000,
        });
      }
    },
    batchCreate() {
      if (this.selectTreeData) {
        if (this.selectTreeData.groupId) {
          this.modalNode.viewpoint.content.treeDataJson.forEach((el) => {
            if (el.id == this.selectTreeData.groupId) {
              this.selectTreeData = el;
            }
          });
        }
        this.batchCreateShow = true;
        // this.modalNode.viewpoint.head.fold.state = false;
        this.modalNode.viewpoint.show = false;
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.batchCreatePage.modalNode.ModelNase.show = true;
            this.$refs.batchCreatePage.form.name = this.selectTreeData
              ? this.selectTreeData.name
              : "";
            this.$refs.batchCreatePage.disabled_name = this.selectTreeData
              ? true
              : false;
          });
        }, 400);
      } else {
        this.$message({
          message: "请先选中一条分组！",
          type: "warning",
          duration: 1000,
        });
      }
    },
    openState() {
      // this.modalNode.viewpoint.head.fold.state = true;
      this.modalNode.viewpoint.show = true;
    },
    addGrouping() {
      this.newPageShow = true;
      // vMap.setCameraViewList();
    },
    closeNewGrouping() {
      this.newPageShow = false;
      this.editTreeData = null;
    },
    checkBoxClick(e, isCheck, arr) {
      if (e.graphic) {
        if (isCheck) {
          this.showModelFun(e.id, true);
          this.addDemoGraphic(e);
        } else {
          //关闭当前模型
          let position = JSON.parse(e.position);
          modelSetMap.hideModel(position);
          this.showModelFun(e.id, false);
        }
      }
    },
    addDemoGraphic(e) {
      let style = JSON.parse(e.graphic);
      let position = JSON.parse(e.position);
      modelSetMap.addDemoGraphic(style.style, position);
    },
    nodeClick(e) {
      this.selectTreeData = e;
      if (e.position) {
        modelSetMap.to_vectorData(e);
      }
    },
    showModelFun(id, type) {
      if (type) {
        if (!this.modalNode.viewpoint.content.checkeArr.includes(id)) {
          this.modalNode.viewpoint.content.checkeArr.push(id);
        }
      } else {
        for (
          let i = 0;
          i < this.modalNode.viewpoint.content.checkeArr.length;
          i++
        ) {
          if (this.modalNode.viewpoint.content.checkeArr[i] == id) {
            this.modalNode.viewpoint.content.checkeArr.splice(i, 1);
          }
        }
      }
    },
    open_new_model(ids) {
      setTimeout(() => {
        this.modalNode.viewpoint.content.checkeArr = this.modalNode.viewpoint.content.checkeArr.concat(
          ids
        );
      }, 1500);
    },
    plotItem_click() {
      this.$emit("plotItem_click", "modelSet");
    },
    externalInit() {},
    onSubmitGroupName(form) {
      if (this.editTreeData) {
        BimGltfGroupingEdit({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          groupId: this.editTreeData.id,
          name: form.name,
          sort: 1,
          isShow: true,
        }).then((res) => {
          this.getData();
          this.newPageShow = false;
          this.editTreeData = null;
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
        });
      } else {
        BimGltfGroupingAdd({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          name: form.name,
          sort: 1,
          isShow: true,
        }).then((res) => {
          if (res.data.code == 200) {
            this.getData();
            this.newPageShow = false;
            this.$message({
              type: "success",
              message: "新建成功!",
            });
          }
        });
      }
    },

    editTree(e) {
      this.editTreeData = e;
      this.newPageShow = true;
      setTimeout(() => {
        this.$refs.newGroupingPage.form.name = e.name;
      }, 200);
    },
    deleteTree(e) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(this.selectTreeData);
          console.log(e);
          BimGltfGroupingDelete({
            groupId: e.id,
          }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            e.children.forEach(el=>{
              let position = JSON.parse(el.position);
              modelSetMap.hideModel(position);
            });
            
            this.getData();
            if (e.id == this.selectTreeData.id) this.selectTreeData = null;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    childrenDelete(e) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          BimGltfPaintingDelete({
            id: e.id,
          }).then((res) => {
            let position = JSON.parse(e.position);
            modelSetMap.hideModel(position);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    childrenEdit(e) {
      this.childrenEditData = e;
      // this.viewpointNode.newGroupingCategory.show = true;
      this.viewpointForm.name = "";
      this.viewpointForm.name = e.name;
      this.viewpointForm.id = e.id;
      this.modalNode.viewpoint.head.fold.state = false;
      this.modalEditorShow = true;
      setTimeout(() => {
        this.$refs.ModalEditor.editModel(e);
        modelSetMap.editModel(e);
      }, 300);
    },
    set_editModel(obj) {
      modelSetMap.set_editModel(obj);
    },
    onSubmitViewpoint() {
      BimGltfPaintingEdit({
        name: this.viewpointForm.name,
        id: this.viewpointForm.id,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.getData();
        this.viewpointNode.newGroupingCategory.show = false;
      });
    },
    closeViewpoint() {
      this.viewpointNode.newGroupingCategory.show = false;
    },

    modalEditorClose() {
      this.modalEditorShow = false;
      this.modalNode.viewpoint.head.fold.state = true;
    },
    onSubmit(obj) {
      let data = modelSetMap.getEditModel(this.childrenEditData);
      let form = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        type: this.childrenEditData.type,
        textName: obj.modelName,
        graphic: JSON.stringify(data.properties),
        position: JSON.stringify(data.geometry.coordinates),
        sort: 1,
        isShow: true,
        groupId: this.childrenEditData.groupId,
        id: this.childrenEditData.id,
      };

      BimGltfPaintingEdit(form).then((res) => {
        if (res.status == 200 && res.data.code == 204) {
          // this.successFun([res.data.data]);
          this.getData();
          this.modalEditorShow = false;
          this.viewpointNode.newGroupingCategory.show = false;
          this.modalNode.viewpoint.head.fold.state = true;
          this.$message({
            type: "success",
            message: "成功!",
          });
          this.modalNode.viewpoint.content.checkeArr.push(
            this.childrenEditData.id
          );
        }
      });
    },
  },
  mounted() {
    this.getData();
    modelSetMap.createdGraphicLayer();
  },
};
